import type { DocumentData } from "firebase/firestore/lite";

export function ifAllUserDetailsAreFilled(
  user: DocumentData | boolean | null,
  _participant: DocumentData,
  project?: DocumentData,
): boolean {
  if (!user || user === true || !project?.registrations) {
    return false;
  }

  if (
    !user ||
    !user.age?.length ||
    !user.gender?.length ||
    (!project?.settings?.demographicData?.withoutPostcode &&
      !user.postcode?.length)
  ) {
    return false;
  }

  const demographicFields = project?.settings?.demographicData?.fields;

  const participant =
    _participant ||
    project?.registrations?.find((e) => e.userId === user?.userId);

  if (demographicFields?.length) {
    for (const { name } of demographicFields) {
      if (!participant?.[name]) {
        return false;
      }
    }
  }

  return true;
}
